module.exports = __webpack_public_path__ + "static/media/Savannah Sullivan Headshot.fbe67870.jpeg";